import { action, makeObservable, observable } from 'mobx';

import { ClickOutsideMaskParams } from '@components/ClickOutsideMask/ClickOutsideMask';

export class Overlay {
    @observable public zIndex?: number;
    @observable public transparentBackground?: boolean;
    @observable public onClickOutside?: () => void;

    constructor({ zIndex, transparentBackground, onClickOutside }: ClickOutsideMaskParams) {
        makeObservable(this);

        this.zIndex = zIndex;
        this.transparentBackground = transparentBackground;
        this.onClickOutside = onClickOutside;
    }

    @action
    public setOverlay({ zIndex, transparentBackground, onClickOutside }: ClickOutsideMaskParams): void {
        this.zIndex = zIndex;
        this.transparentBackground = transparentBackground;
        this.onClickOutside = onClickOutside;
    }

    @action
    public reset(): void {
        this.zIndex = undefined;
        this.transparentBackground = undefined;
        this.onClickOutside = undefined;
    }
}
